import { replace } from 'connected-react-router';

// Types
import { AppDispatch, AppGetState } from 'types/RootState.types';

// Config
import { REBATCH_ORDER } from '@constants/actionConstants';
import routeConstants from '@constants/routeConstants';
import { showDisableSiteSpinner } from '@redux/actions/app/appActions';
import { getOrderFormData } from '@redux/actions/payment/orderFormActions';
import { initDeliveryPage } from '@redux/actions/delivery/deliveryActions';
import { rebatchOrder } from '@redux/actions/edit-basket/editBasketActions';
import { isClickAndCollectChoice } from '@utils/delivery/deliveryHelper';

export const handleInconsistentOrderFormState = () => async (dispatch: AppDispatch, getState: AppGetState) => {
  const address = getState()?.delivery?.confirmedDeliveryAddress;
  const selectedDeliveryChoiceId = getState()?.delivery?.selectedDeliveryChoiceId;
  dispatch(showDisableSiteSpinner());

  await dispatch(getOrderFormData({ isCustomerAction: true }));
  const response = await dispatch(rebatchOrder(address));

  if (response?.type === `${REBATCH_ORDER}.SUCCESS`) {
    const currentLocation = getState()?.router?.location?.pathname ?? '';
    const isOnPayment =
      currentLocation.includes(routeConstants.PAYMENT) ||
      currentLocation.includes(routeConstants.PAYMENT_POS_CREDIT_CALLBACK);
    const isOnDelivery = currentLocation.includes(routeConstants.DELIVERY);
    const isOnClickCollect = currentLocation.includes(routeConstants.CLICK_AND_COLLECT);

    if (isOnPayment) {
      if (isClickAndCollectChoice(selectedDeliveryChoiceId)) {
        await dispatch(replace(routeConstants.CLICK_AND_COLLECT));
      } else {
        await dispatch(replace(routeConstants.DELIVERY));
      }
    }
    // initDeliveryPage() is called automatically when you navigate to
    // /delivery or /click-and-collect from /payment
    // so if we are already on /delivery or /click-and-collect we need to call manually here
    if (isOnClickCollect || isOnDelivery) {
      await dispatch(initDeliveryPage({ refresh: true }));
    }
  }
};

export default handleInconsistentOrderFormState;
